<template>
  <v-row class="px-0 pt-10 mt-5">
    <v-col
        cols="12"
        v-if="!loading && hasData"
        data-testid="blogs-list"
        class="card-border-radius d-flex flex-column pa-sm-10"
        style="background-color: #FFFFFF; min-height: 70vh"
    >
      <div class="d-flex flex-row align-center mb-2">
        <h2 data-testid="Blog Tags" class="font-weight-bold pr-1" style="color: #0033AA">
          Trending Now
        </h2>
        <img :src="trendingIcon" style="width: 1em; height: 1em" alt="trending-icon"/>
        <v-spacer/>
      </div>
      <v-list class="d-flex flex-column card-border-radius" style=" border: .01em solid #C9C9C9;">
        <v-row class="ml-2 mr-1 mb-2" style="border-bottom: .05em solid #C9C9C9; color: #C9C9C9; font-size: 1.4em; font-weight: 600">
          <v-col cols="9" md="4" class="pl-5">#tag</v-col>
          <v-col  cols="2" md="8"  class="d-flex align-start">Blogs</v-col>
        </v-row>
        <v-list-item  v-for="tag in tags" :key="tag.id" class="pa-3 mx-4 card-border-radius">
          <v-list-item-content>
            <v-row>
              <v-col cols="10" md="4" style="color: #0035B0; font-weight: 400; font-size: 1.2em">#{{tag.name}}</v-col>
              <v-col cols="2" md="8" class="d-flex align-start" style="color: #A0A0A0; font-size: 1.2em">{{tag.tagged_posts || 0}}</v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <infinite-loading spinner="waveDots" @infinite="fetchMoreTags">
              <div slot="no-results">
                <v-chip small text-color="primary">You have caught up</v-chip>
              </div>
              <div slot="no-more">
                <v-chip small text-color="primary">You have caught up</v-chip>
              </div>
            </infinite-loading>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col cols="12" v-if="(!loading && !hasData)" class="bottom-wrapper">
      <NoData
          data-testid="empty-blog-tags-list"
          :image="emptyPage"
          :title="`No blogs tags yet`"
      />
    </v-col>
    <v-col cols="12" v-if="loading" class="d-flex flex-row flex-wrap justify-space-around">
      <v-skeleton-loader
          data-testid="v-skeleton-loader"
          v-for="x in 9"
          :key="x"
          class="my-3"
          type="card"
          width="100%"
      />
    </v-col>
  </v-row>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import NoData from "@/components/NoData";
import emptyPage from "@/assets/no_data.svg";
import InfiniteScroll from "@/mixins/InfiniteScroll";
import trendingIcon from "@/assets/trending.svg"
export default {
  mixins: [InfiniteScroll],
  metaInfo() {
    return {
      title: "Guiomentor - Blog Tags",
      url: window.location.href
    };
  },
  components: {NoData},
  data() {
    return {
      emptyPage,
      trendingIcon,
      loading: false,
      limit: 12,
      offset: 12,
      followLoading: false,
      loadingMore: false,
      fetchUrl: "",
      activeTag: {
        id: '',
        name: '',
        description: '',
        has_followed: '',
        color_code: '',
        tagged_posts: 0,
      },
      defaultColors: [ '#cc0000','#00cc00', '#0000cc'],
    }
  },
  beforeMount() {
    this.fetchUrl = `blogs/tags/?limit=${this.limit}`
    this.SET_BLOG_TAGS([])
    this.loadTags()
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/GET_IS_AUTHENTICATED",
      tags: "blogs/GET_BLOG_TAGS"
    }),
    hasData() {
      return Boolean(this.tags.length)
    },
  },
  methods: {
    ...mapMutations({
      SET_BLOG_TAGS: "blogs/SET_BLOG_TAGS"
    }),
    async loadTags() {
      try {
        this.loading = true
        const {data} = await this.axios.get(this.fetchUrl)
        const tags = data.results.map(item => ({
          ...item,
          color_code: item.color_code ? item.color_code :
              this.defaultColors[Math.floor(Math.random()*this.defaultColors.length)]
        }))
        this.SET_BLOG_TAGS(tags)
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$snackbar.showMessage({
          content: this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      }
    },
    fetchMoreTags($state) {
      this.infiniteHandler($state, "SET_BLOG_TAGS")
    },
    async followTag(tag) {
      try {
        this.followLoading = true;
        this.activeTag = tag
        await this.axios.post(`blogs/tags/following/?tag_id=${tag.id}`, {
          token: localStorage.getItem("access_token"),
        });
        const tags = this.tags.map(item => ({
          ...item,
          has_followed: this.activeTag.id === item.id ?
              !item.has_followed : item.has_followed
        }))
        this.SET_BLOG_TAGS(tags)
        this.followLoading = false;
      } catch (error) {
        this.followLoading = false;
        this.$snackbar.showMessage({
          content: this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";
.tags-header {
  background-color: #FFFFFF;
  color: #0035B0;
}
.card-border-radius {
  border-radius: .5em;
}
.v-btn {
  text-transform: none !important;
  padding: 1.5em !important;
  font-size: 1.2em !important;
}

.v-list-item:hover {
  background-color: rgba(0, 53, 176, 0.09);
}

</style>
